import ISherkatBimehGhablDto from 'Feature/Khodro/ShakhsSales/SakhsSalesBimehNameh/Commands/Soddor/ISherkatBimehGhablDto';

const SherkatBimehGhablInitialState: ISherkatBimehGhablDto = {
  noeSherkatBimehCoreId: '',
  shomarehBimehNameh: '',
  noeSherkatBimeh: '',
  tarikhEnghezaBimehnameh: null,
  niazBeEstelamBimehMarkazi: false,
  tarikhShorooBimehnameh: null,
};

export default SherkatBimehGhablInitialState;
